<script>
  import rubricItemsJSON from '@/assets/courseReview/rubric_items.json'

  export default {
    name: 'rubricItem',
    data() {
      return {
        comment: null,
        attention: true
      }
    },
    computed: {
      reviewInfo() {
        return this.$store.getters.reviewInfo
      },
      rubricItemRating: {
        get: function() {
          return this.reviewInfo.ratings[0][`rating_${this.rubricId}`]
        },
        set: async function(newValue) {
          try {
            await this.$store.dispatch('cr_callAPI', {
              url: `/r/reviews/${this.reviewInfo.id}/rating`,
              method: 'post',
              data: {
                item: `rating_${this.rubricId}`,
                item_value: newValue
              }
            })
            const response = await this.$store.dispatch('cr_callAPI', {
              url: `/r/reviews/${this.reviewInfo.id}`
            })
            response.user_token = this.reviewInfo.user_token
            await this.$store.commit('cr_updateReviewInfo', response)
          } catch (err) {
            this.$root.$bvToast.toast(
              `Error entering rating. If this problem persists, please contact the OFDIT lead. ${err.message}.`,
              {
                title: 'Error',
                toaster: 'b-toaster-top-center',
                variant: 'danger'
              }
            )
          }
        }
      },
      rubricItem() {
        return rubricItemsJSON.find(item => item.id === this.rubricId)
      },
      rubricItemComments() {
        if (this.reviewInfo.comments) {
          return this.reviewInfo.comments.filter(
            comment => comment.item_id === this.rubricId
          )
        } else {
          return null
        }
      },
      needsAttention() {
        if (this.reviewInfo.reviewer_role === 'Peer reviewer') {
          if (this.rubricItem.peer_attention === false) {
            return false
          }
        }
        if (this.reviewInfo.reviewer_role === 'OFDIT reviewer') {
          if (this.rubricItem.ofdit_attention === false) {
            return false
          }
        }
        return true
      }
    },
    methods: {
      editComment(comment) {
        this.$store.commit('cr_setEditComment', comment)
        this.$bvModal.show('edit-modal')
      },
      async submitComment() {
        try {
          if (!this.comment) {
            throw Error('You cannot create an empty comment')
          }
          const comments = [
            {
              item_id: this.rubricId,
              content: this.comment.trim()
            }
          ]
          await this.$store.dispatch('cr_callAPI', {
            url: `/r/comments/${this.reviewInfo.id}`,
            method: 'post',
            data: { comments }
          })
          this.$root.$bvToast.toast(
            `You have successfully entered a comment.`,
            {
              title: 'Success',
              autoHideDelay: 1000,
              toaster: 'b-toaster-top-center',
              variant: 'success'
            }
          )
          this.comment = null
        } catch (err) {
          this.$root.$bvToast.toast(
            `Error creating comment. If the problem persists, please contact the OFDIT lead.
        ${err.message}.`,
            {
              title: 'Error',
              toaster: 'b-toaster-top-center',
              variant: 'danger'
            }
          )
        } finally {
          const comments = await this.$store.dispatch('cr_callAPI', {
            url: `/r/reviews/${this.reviewInfo.id}/comments`
          })
          this.$store.commit('cr_updateComments', comments)
        }
      }
    },
    props: {
      rubricId: Number
    }
  }
</script>
<template>
  <div>
    <b-row>
      <b-col
        md="9"
        class="ml-3"
        align-self="stretch"
        v-bind:class="{ 'attention-item': needsAttention }"
      >
        <p><b-icon icon="clipboard-check"></b-icon> {{ rubricItem.text }}</p>
      </b-col>
      <b-col md="2">
        <div v-if="rubricId < 99">
          <b-form-group label="Please rate:">
            <b-form-radio
              v-model="rubricItemRating"
              :name="`rubric-rating-${this.rubricId}`"
              value="Meets standard"
              >Meets Standard</b-form-radio
            >
            <b-form-radio
              v-model="rubricItemRating"
              :name="`rubric-rating-${this.rubricId}`"
              value="Needs work"
              >Needs work</b-form-radio
            >
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <div v-if="rubricItemComments">
      <b-row v-for="comment in rubricItemComments" :key="comment.id">
        <b-col cols="9">
          <p>
            <strong>You wrote:</strong>
            {{ comment.content }}
          </p>
        </b-col>
        <b-col>
          <b-button
            @click="editComment(comment)"
            class="mb-4"
            size="sm"
            variant="outline-warning"
            >Edit</b-button
          >
        </b-col>
      </b-row>
    </div>
    <b-form-group
      label="Enter a comment"
      :label-for="`rubric-comment-${rubricId}`"
      class="w-75"
    >
      <b-form-textarea
        :id="`rubric-comment-${rubricId}`"
        name="comment"
        v-model="comment"
        rows="4"
      ></b-form-textarea>
    </b-form-group>
    <b-button class="my-2" variant="success" size="sm" @click="submitComment"
      >Submit comment</b-button
    >
    <hr />
  </div>
</template>

<style>
  .attention-item {
    background-color: #e0ffff;
    border-radius: 10px;
  }
  p {
    white-space: pre-wrap;
  }
</style>
